import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { useGetAuftragMutation } from '../../api/AuftragAPI';
import { IAuftrag } from '../../types/Types';
import AuftragTerminAendernComponent from '../AuftragTerminAendernComponent/AuftragTerminAendernComponent';

interface ComponentProps {
  close: () => void;
  refresh?: () => void;
  dialogVisible: boolean;
  uid_auftrag: string | undefined;
  statusChanged: () => void;
}

/**
 * @author noone
 */
const DialogAuftragTerminAendernComponent: React.FC<ComponentProps> = (props) => {

  const [getAuftragAPI] = useGetAuftragMutation();

  const [auftrag, setAuftrag] = useState<IAuftrag>();

  const closeDialog = () => {
    props.refresh && props.refresh();
    props.close();
  }

  const lade = () => {

    if (!props.uid_auftrag) return;

    getAuftragAPI(props.uid_auftrag).unwrap()
      .then(data => setAuftrag(data))
      .catch((error) => console.error("Fehler :", error))
      ;
  }

  useEffect(() => {
    lade();
  }, [props.uid_auftrag]);

  return (
    <>

        <Dialog
          visible={props.dialogVisible}
          onHide={() => props.close()}
          header={auftrag ? `Auftrag: ${auftrag.art} - ${auftrag.name_endkunde} - ${auftrag.stadt_lieferadresse} - ${auftrag.strasse_lieferadresse} ${auftrag.hausnummer_lieferadresse}` : "Dialog"}
          modal
          style={{ width: '100vw', height: '50vh', position: 'fixed', bottom: 0, left: 0, top: 'auto' }}
        >
          <AuftragTerminAendernComponent
            refresh={closeDialog}
            uid_auftrag={props.uid_auftrag}
            statusChanged={props.statusChanged}
          />
        </Dialog>
    </>
  );

}

export default DialogAuftragTerminAendernComponent;